import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-session-out',
  templateUrl: './session-out.component.html',
  styleUrls: ['./session-out.component.css']
})
export class SessionOutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
